import Vue from "vue";
Vue.mixin({
    methods: {
        addClientAndCandidateTags(listFields) {
            // Insert client (poster) fields
            const listClientFields = this.getListFieldsByUserType(
                this.$store.getters.profileBuilderList,
                "Client"
            );
            for (const field of listClientFields) {
                if (!field.model) {
                    continue;
                }
                listFields.push({
                    label: `${field.label} (Client - Job Poster)`,
                    model: `client_${field.model}`,
                });
            }
            // Insert candidate fields
            const listCandidateFields = this.getListFieldsByUserType(
                this.$store.getters.profileBuilderList,
                "Candidate"
            );
            for (const field of listCandidateFields) {
                if (!field.model) {
                    continue;
                }
                listFields.push({
                    label: `${field.label} (Candidate)`,
                    model: `candidate_${field.model}`,
                });
            }
        }
    }
});


// WEBPACK FOOTER //
// ./src/mixins/template-handling.js